/* eslint-disable no-param-reassign */
export default (
  state,
  {
    meta: {
      arg: { id },
    },
  }
) => {
  const upload = state[id];
  if (upload) {
    upload.failed = true;
    upload.uploading = false;
  }
};
